<template>
	<BaseCenteredPage v-bind="{hideHelpButton, hideLogoutButton}">
		<template v-if="$slots['nav-left']" #nav-left><slot name="nav-left" /></template>
		<template v-if="$slots['nav-right']" #nav-right><slot name="nav-right" /></template>
		<main class="flex flex-col items-center justify-center" style="max-width: 420px">
			<div class="mb-48">
				<slot name="icon"><BaseIcon :name="$store.productIcon" class="w-40 h-40" /></slot>
			</div>
			<h2 v-if="$slots.subtitle" class="mb-20 text-lg text-gray-100 text-code-strong">
				<slot name="subtitle" />
			</h2>
			<h1 class="mb-16 text-center text-gray-100 text-strong-lg">
				<slot name="title" />
			</h1>
			<p v-if="$slots.details" class="mb-48 text-center text-gray-300">
				<slot name="details" />
			</p>
			<slot />
			<slot v-if="!hideActions" name="actions" v-bind="{loginWithDifferentAccount}">
				<RouterLink to="/" class="button-green">Back to my account</RouterLink>
				<button
					v-if="!hideLogoutButton"
					class="flex mx-auto mt-20 link-white text-strong-base"
					@click="loginWithDifferentAccount"
				>
					Log in with different account
				</button>
			</slot>
		</main>
	</BaseCenteredPage>
</template>

<script>
export default {
	name: 'BaseCenteredMessage',
	props: {
		hideHelpButton: Boolean,
		hideLogoutButton: Boolean,
		hideActions: Boolean,
	},
	methods: {
		async loginWithDifferentAccount() {
			if (localStorage) {
				localStorage.redirectAfterLogin = window.location.pathname + window.location.search
			}
			await this.$auth.logout({
				logoutOfAllTargets: true,
				postLogoutRedirectUri: `${import.meta.env.VUE_APP_URL}/auth/start-sso`,
			})
		},
	},
}
</script>
